import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { useGetRecentPayouts } from "../../../hooks/queries/useTransactionQueries";
import CustomSkeletonTable from "../../ui/CustomSkeletonTable/CustomSkeletonTable";
import FetchFeedback from "../../ui/CustomFetchFeedback/CustomFetchFeedback";
import DashboardTableTanStack from "../tables/DashboardTanStackTable";
import CustomButton from "../../ui/CustomButton/CustomButton";

export default function RecentPayoutsSection() {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading, isFetching, isError, refetch } = useGetRecentPayouts(
    pagination.pageSize,
  );

  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const previousDataRef = useRef(null);

  useEffect(() => {
    if (!isLoading && !initialLoadDone) {
      setInitialLoadDone(true);
    }
  }, [isLoading, initialLoadDone]);

  useEffect(() => {
    if (data) {
      previousDataRef.current = data;
    }
  }, [data]);

  const displayData = data || previousDataRef.current;

  const handleSeeAllClick = () => {
    navigate("/transaction-page");
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h1 className="text-base sm:text-lg font-semibold text-gray-900">Recent payouts</h1>
        <CustomButton size="xs" onClick={handleSeeAllClick}>
          see all <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
        </CustomButton>
      </div>

      {!initialLoadDone && isLoading && (
        <CustomSkeletonTable
          columns={[1, 2, 3, 4, 5, 6, 7, 8]}
          rowCount={pagination.pageSize}
        />
      )}

      {isError && !displayData && (
        <FetchFeedback
          message="Failed to load recent payouts."
          onRetry={refetch}
        />
      )}

      {initialLoadDone && displayData && (
        <DashboardTableTanStack
          data={displayData}
          pagination={pagination}
          onPaginationChange={setPagination}
          isFetching={isFetching}
        />
      )}
    </div>
  );
}
